import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { TributacaoBuscarPorOperacao } from "src/services/Fiscal.Service";
import { TributacaoDto } from "../../Tributacao/Tributacao/Tributacao.Dto";
import { showToast } from "src/componentes";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";
import { useDelayedLoading } from "src/hook/useDelayedLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

const NFeCadastroTributacaoView = () => {
  const location = useLocation();
  const { loading, start, stop } = useDelayedLoading(500);
  const [data, setData] = useState<TributacaoDto[] | undefined>([]);
  const nf = getLocal<NFeDto>(STORAGENFE_KEY);
  const tipoOperacao = nf?.tipoOperacao;
  const tributacaoSelecionada = nf?.tributacaoId ?? undefined;
  const selecionado = tributacaoSelecionada != undefined;

  const navigate = useNavigate();

  const handleVoltar = () => () => {
    navigate("../finalidade");
  };

  const handleSalvar = (id: number) => () => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      tributacaoId: id,
    });
    handleProximo();
  };

  const handleProximo = () => {
    navigate("../destinatario");
  };

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      start();
      if (tipoOperacao == undefined) {
        handleVoltar()();
        return;
      }
      await TributacaoBuscarPorOperacao(tipoOperacao)
        .then((response) => {
          if (response.data.success) {
            setData(response.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
          showToast({
            message: "Ocorreu erro ao buscar dados",
            title: "Erro",
            variant: "Danger",
          });
          return undefined;
        })
        .finally(() => {
          stop();
        });
    };
    Load();
    return () => {
      stop();
      controller.abort();
    };
  }, []);

  return (
    <>
      {!loading ? (
        <>
          <Row>
            <Col>
              {data && data.length > 0 ? (
                <Table responsive striped hover>
                  <thead>
                    <tr>
                      <th></th>
                      <th className="col-6">Nome</th>
                      <th className="col-4">Cfop</th>
                      <th className="d-none d-sm-table-cell col-2">Operação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item) => {
                      const selecionado = tributacaoSelecionada === item.id;

                      return (
                        <tr
                          key={item.id}
                          onClick={handleSalvar(item.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>
                            {selecionado && (
                              <FontAwesomeIcon
                                icon={faCircle}
                                className="text-success"
                                style={{ fontSize: "0.6rem" }}
                              />
                            )}
                          </td>
                          <td className="col-6">{item.nome}</td>
                          <td className="col-4">
                            {item.cfop.map((x) => x.cfop).join(" - ")}
                          </td>
                          <td className="d-none d-sm-table-cell col-2">
                            {item.tipoOperacao} - {item.tipoOperacaoDescricao}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <Form.Text>Sem Dados</Form.Text>
              )}
            </Col>
          </Row>
          <div className="fixed-bottom">
            <Container className="py-3">
              <Row>
                <Col xs={selecionado ? 6 : 12} className="d-grid">
                  <Button variant="outline-secondary" onClick={handleVoltar()}>
                    Voltar
                  </Button>
                </Col>
                {selecionado && (
                  <Col xs={selecionado ? 6 : 12} className="d-grid">
                    <Button variant="outline-primary" onClick={handleProximo}>
                      Próximo
                    </Button>
                  </Col>
                )}
              </Row>
            </Container>
          </div>
        </>
      ) : (
        <Placeholder as={FloatingLabel} animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </>
  );
};
export default NFeCadastroTributacaoView;
